import { numberToPrettyString, plural } from '@cian/utils';
import { NBSP } from '../../../constants/symbols';

export const getPriceText = (price: number) => {
  return `${numberToPrettyString(price)}${NBSP}${plural(price, ['рубль', 'рубля', 'рублей'])}`;
};
